import React from 'react'
import BigAdd from './BigAdd'
import WorldCards from './WorldCards'
import BollywoodNews2 from './BollywoodNews2';
import Business3 from './Business3'
import { Helmet, HelmetProvider } from 'react-helmet-async';
// import BusinessDetailsD from './BusinessDetailsD';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-solid-svg-icons";

// import './style1.css';

function World() {
    return (
        <div>
            <div className="ak-post-wrapper" style={{ transform: "none" }}>
                <div
                    className="ak-content-wrap ak-post-wrap ak-layout-style-1 clearfix ak-post-style-7 clearfix"
                    style={{ transform: "none" }}
                >
                    <div className="ak-container" style={{ transform: "none" }}>
                        <div className="ak-content" style={{ transform: "none" }}>
                            <div className="" style={{ transform: "none" }}>
                                <div className='mt-2'>
                                    <BigAdd />
                                </div>
                                <div>
                                </div>
                                <div>
                                    <h1 className='head' style={{ color: 'crimson', marginLeft: 10 }}>
                                        दुनिया
                                    </h1>
                                </div>
                                <div className="row" style={{ transform: "none" }}>
                                    <div className="ak_column_1 col-md-9">
                                        <div className="ak-article-inner">
                                            <div className=''>
                                                <div className="ak-block-header ak-block-header-style-5 no-tabs">
                                                    <div
                                                        className="main-wdgt"
                                                        id="widget-rs-4937"
                                                        data-vars-widget-type="home"
                                                        data-vars-widget-name="astrology"
                                                        data-vars-orderid={10}
                                                    >
                                                        <div className='mt-2 '>
                                                            <WorldCards />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className="ak_column_ col-md-3 sidebar-column sidebar-column-primary-right sticky-sidebar"
                                        style={{
                                            position: "relative",
                                            overflow: "visible",
                                            boxSizing: "border-box",
                                            minHeight: 1
                                        }}
                                    >
                                        <div
                                            className="theiaStickySidebar"
                                            style={{
                                                paddingTop: 0,
                                                paddingBottom: 1,
                                                position: "sticky",
                                                transform: "none",
                                                top: 0,
                                                left: "914.5px"
                                            }}
                                        >
                                            <div className="sidebar post-sidebar">
                                                <BollywoodNews2 />
                                                <Business3 />
                                                {/* <Crime />
                                                <TajaKhabr />
                                                <TajaSlide />
                                                <Sehat />
                                                <FakeKhabre /> */}
                                            </div>
                                            <div
                                                className="resize-sensor"
                                                style={{
                                                    position: "absolute",
                                                    inset: 0,
                                                    overflow: "hidden",
                                                    zIndex: -1,
                                                    visibility: "hidden"
                                                }}
                                            >
                                                <div
                                                    className="resize-sensor-expand"

                                                    style={{
                                                        position: "absolute",
                                                        left: 0,
                                                        top: 0,
                                                        right: 0,
                                                        bottom: 0,
                                                        overflow: "hidden",
                                                        zIndex: -1,
                                                        visibility: "hidden"
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            left: 0,
                                                            top: 0,
                                                            transition: "all 0s ease 0s",
                                                            width: 410,
                                                            height: 1260
                                                        }}
                                                    />
                                                </div>
                                                <div
                                                    className="resize-sensor-shrink"
                                                    style={{
                                                        position: "absolute",
                                                        left: 0,
                                                        top: 0,
                                                        right: 0,
                                                        bottom: 0,
                                                        overflow: "hidden",
                                                        zIndex: -1,
                                                        visibility: "hidden"
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            left: 0,
                                                            top: 0,
                                                            transition: "0s",
                                                            width: "200%",
                                                            height: "200%"
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default World
